import { connect } from "react-redux";
import { statsService } from "service/stats";
import { SimpleFetchController } from "ui/fetch/fetch-controller/simple-fetch-controller";

function mapStateToProps(_state, props) {
  return {
    injectAs: "stats",
    objectId: "playerVersionStats",
  };
}

function mapDispatchToProps() {
  return {
    fetchObject: statsService.getPlayerVersionStats,
  };
}

const ConnectedFetchPlayerVersionStatsController = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SimpleFetchController);

export { ConnectedFetchPlayerVersionStatsController };
